__turbopack_context__.v({
  "className": "grotesquemtfont_e035b0fb-module__R0oiKG__className",
  "variable": "grotesquemtfont_e035b0fb-module__R0oiKG__variable",
});
